import { createSlice } from "@reduxjs/toolkit";
import { INITIAL_VALUES } from "../models/FormInitialValues";
import { ShiftParameters } from "../models/ShiftParameters";

const ShiftsCrewsInitialState: {
	shifts: ShiftParameters[];
	shiftTableData: ShiftParameters;
} = {
	shifts: [],
	shiftTableData: INITIAL_VALUES,
};

export const ShiftsCrewsReducer = createSlice({
	name: "__",
	initialState: ShiftsCrewsInitialState,
	reducers: {
		setShiftsCrews(state, { payload }) {
			state.shifts = payload;
		},
		setShiftTableData(state, { payload }) {
			state.shiftTableData = payload;
		},
	},
});
